import Main from "@/views/Main.vue";
const customerRoutes = [
  {
    path: "/productTrace",
    icon: "arrow-swap",
    name: "ProductTrace",
    title: "ProductTrace",
    component: Main,
    children: [
      {
        path: "discountConvert",
        title: "商家折扣文件转换",
        name: "DiscountConvert",
        component: (resolve) => {
          require(["@/views/trace/discountConvert/index.vue"], resolve);
        },
      },
      {
        path: "product",
        title: "Product",
        name: "product",
        component: (resolve) => {
          require(["@/views/trace/product-trace.vue"], resolve);
        },
      },
      {
        path: "api-dashboard",
        title: "API dashboard",
        name: "apiDashboardChild",
        component: (resolve) => {
          require(["@/views/api-dashboard/api-dashboard.vue"], resolve);
        },
      },
      {
        path: "err-iframe",
        title: "Error Data",
        name: "errorData",
        component: (resolve) => {
          require(["@/views/api-dashboard/err-iframe.vue"], resolve);
        },
      },
      {
        path: "email",
        title: "订单邮件管理",
        name: "email",
        component: (resolve) => {
          require(["@/views/trace/email/email.vue"], resolve);
        },
      },
      {
        path: "manual",
        title: "Manual Action",
        name: "ManualAction",
        component: (resolve) => {
          require(["@/views/trace/manual.vue"], resolve);
        },
      },
      {
        path: "order-push",
        title: "订单推送",
        name: "orderPush",
        component: (resolve) => {
          require(["@/views/trace/order-push.vue"], resolve);
        },
      },
      {
        path: "dict",
        title: "字典表",
        name: "DictManage",
        component: (resolve) => {
          require(["@/views/trace/cn/dict.vue"], resolve);
        },
      },
      {
        path: "esIndex",
        title: "ES刷新",
        name: "ESIndex",
        component: (resolve) => {
          require(["@/views/trace/esRefresh.vue"], resolve);
        },
      },
      {
        path: "blackAndWhiteList",
        title: "买手店黑白名单",
        name: "blackAndWhiteList",
        component: (resolve) => {
          require(["@/views/trace/blackAndWhiteList/code.vue"], resolve);
        },
      },
      {
        path: "blackAndWhiteList/detail",
        title: "买手店黑白名单详情",
        name: "blackAndWhiteDetail",
        component: (resolve) => {
          require(["@/views/trace/blackAndWhiteList/props.vue"], resolve);
        },
      },
      {
        path: "job",
        title: "商家全量推送",
        name: "TraceJob",
        component: (resolve) => {
          require(["@/views/trace/job.vue"], resolve);
        },
      },
      {
        path: "/productTrace/product/stockTrace/:skuId",
        parentPath: "/productTrace/product",
        parentName: "Product",
        title: "Stock Trace",
        name: "stockTrace",
        component: (resolve) => {
          require(["@/views/trace/stock-trace/stock-trace.vue"], resolve);
        },
      },
      {
        path: "/productTrace/product/newStockTrace/:skuId",
        parentPath: "/productTrace/product",
        parentName: "Product",
        title: "New Stock Trace",
        name: "newStockTrace",
        component: (resolve) => {
          require(["@/views/trace/stock-trace/new-stock-trace.vue"], resolve);
        },
      },
      {
        path: "troubleshooting/index",
        title: "troubleshooting",
        name: "troubleshooting",
        component: (resolve) => {
          require(["@/views/trace/troubleshooting/index.vue"], resolve);
        },
      },
      {
        path: "invoiceConfig",
        title: "商家发票解析配置",
        name: "商家发票解析配置",
        component: (resolve) => {
          require(["@/views/trace/invoiceConfig.vue"], resolve);
        },
      },
      {
        path: "importDwSpuId",
        title: "导入DW_SPU_ID",
        name: "导入DW_SPU_ID",
        component: (resolve) => {
          require(["@/views/trace/importDwSpuId.vue"], resolve);
        },
      },

      // ── CN 路由 ──
      {
        path: "cn/order-push",
        title: "订单推送(CN)",
        name: "orderPushCn",
        component: (resolve) => {
          require(["@/views/trace/cn/order-push.vue"], resolve);
        },
      },
      {
        path: "cn/job",
        title: "商家全量推送(CN)",
        name: "TraceJobCn",
        component: (resolve) => {
          require(["@/views/trace/cn/job.vue"], resolve);
        },
      },
      {
        path: "cn/invoiceConfig",
        title: "商家发票解析配置(CN)",
        name: "invoiceConfigCn",
        component: (resolve) => {
          require(["@/views/trace/cn/invoiceConfig.vue"], resolve);
        },
      },
      {
        path: "cn/blackAndWhiteList",
        title: "买手店黑白名单(CN)",
        name: "blackAndWhiteListCn",
        component: (resolve) => {
          require(["@/views/trace/cn/blackAndWhiteList/code.vue"], resolve);
        },
      },
      {
        path: "cn/blackAndWhiteList/detail",
        title: "买手店黑白名单详情(CN)",
        name: "blackAndWhiteDetailCn",
        component: (resolve) => {
          require(["@/views/trace/cn/blackAndWhiteList/props.vue"], resolve);
        },
      },
    ],
  },
  {
    path: "/taskManage",
    icon: "android-menu",
    title: "任务管理",
    component: Main,
    children: [
      {
        path: "",
        title: "任务管理",
        name: "taskManage",
        component: (resolve) => {
          require(["@/views/taskManage/index.vue"], resolve);
        },
      },
      {
        path: "/detail",
        title: "任务管理详情",
        name: "taskManageDetail",
        component: (resolve) => {
          require(["@/views/taskManage/detail.vue"], resolve);
        },
      },
    ],
  },
  {
    path: "/dataMonitoring",
    icon: "android-menu",
    title: "数据监控",
    component: Main,
    children: [
      {
        path: "",
        title: "数据监控",
        name: "dataMonitoring",
        component: (resolve) => {
          require(["@/views/dataMonitoring/index.vue"], resolve);
        },
      },
      {
        path: "detail",
        title: "数据监控",
        name: "dataMonitoringDetail",
        component: (resolve) => {
          require(["@/views/dataMonitoring/detail.vue"], resolve);
        },
      },
    ],
  },
];

export default customerRoutes
